.root {
  align-self: stretch;
  margin: 2px 2px;
}

.head {
  display: flex;
  align-items: center;
  gap: 9px;
  width: 100%;
  padding: 6px 11px;
  border: 1px dashed var(--line);
  border-radius: 10px;
  background: transparent;
  color: var(--ink-3);
  font: inherit;
  font-size: 11.5px;
  font-weight: 500;
  text-align: left;
  cursor: pointer;
}

.head:hover {
  background: var(--sunk);
  color: var(--ink-2);
}

.label {
  flex: 1;
  min-width: 0;
}

.time {
  flex-shrink: 0;
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 9.5px;
  color: var(--ink-4);
}

.chevron {
  flex-shrink: 0;
  transition: transform 0.16s ease;
}

.chevronOpen {
  transform: rotate(180deg);
}

.items {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
}

.item {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 11px;
  border-radius: 8px;
  background: var(--sunk);
  color: var(--ink-2);
  font-size: 11.5px;
  line-height: 1.4;
}

.itemText {
  min-width: 0;
}

.itemTime {
  flex-shrink: 0;
  font-family: 'JetBrains Mono Variable', monospace;
  font-size: 9.5px;
  color: var(--ink-4);
}
